import {DocumentEntityType} from './document-entity-type.enum';
import {IHaveName} from '../common/have-name.interface';
import {IDocumentType} from './document-type.interface';

export class EcaDocumentType implements IDocumentType {
  constructor(iDocumentType?: IDocumentType) {
    this.id = iDocumentType?.id || '00000000-0000-0000-0000-000000000000';
    this.name = iDocumentType?.name || '';
    this.description = iDocumentType?.description || '';
    this.documentEntityType = iDocumentType?.documentEntityType || null;
    this.isSelected = iDocumentType?.isSelected || true;
    this.isDefault = iDocumentType?.isDefault || false;
  }

  id: string;
  name: string;
  description: string;
  documentEntityType: DocumentEntityType;
  isSelected: boolean;
  isDefault: boolean;
}
